module.exports = __webpack_public_path__ + "static/media/notification-buy.a6db4dee.png";